import React from 'react'
import Bredcom from '../../Bradcom/Main'
import Services2 from '../../Menhome/Services2'
import Book from '../../Menhome/Book';
import Painting from '../../Menhome/Painting';

const Main = () => {

  return (
    <>
        <main>
           <Bredcom title={"Servicios"} subtitle={"Inicio"} newtitle={"Servicios"} />
           <Services2></Services2>
           <Painting></Painting>
           <Book/>
        </main>
    </>
  )
}

export default Main